<script lang="ts" setup>
import VBackButton from '@components/buttons/VBackButton/VBackButton.vue';
import VCard from '@components/card/VCard/VCard.vue';
import VLoader from '@components/loader/VLoader.vue';
import VFormPlainDataListbox from '@modules/forms/components/inputs/VFormPlainDataListbox/VFormPlainDataListbox.vue';
import VFormSelectInput from '@modules/forms/components/inputs/VFormSelectInput/VFormSelectInput.vue';
import VFormTextInput from '@modules/forms/components/inputs/VFormTextInput/VFormTextInput.vue';
import { GROUPS_OF_ADMINS_LIST_ROUTE_NAME } from '@modules/groups-of-admins/constants';
import { TRANSLATION_GROUPS_OF_ADMINS_EDIT } from '@modules/groups-of-admins/submodules/edit/constants';
import {
  useGroupsOfAdminEditPage,
} from '@modules/groups-of-admins/submodules/edit/pages/GroupsOfAdminEditPage/composables';

const {
  selectValue,
  currentAdminValue,
  groupMembersList,
  isLoadingGroupMembers,
  isLoadingCurrentAdminData,
  isLoadingAdminOwnerChange,
  ownersDataOptions,
  onChange,
  onChangeParticipant,
} = useGroupsOfAdminEditPage();
</script>

<template>
  <VCard v-data-qa-auto-id="'GroupsOfAdminEditPage'"
    :title="$getTranslation(TRANSLATION_GROUPS_OF_ADMINS_EDIT, 'HEADER_SETTINGS')"
    type="form"
  >
    <VLoader
      :loading="isLoadingCurrentAdminData"
      min-height="4rem"
      mode="overlay"
    >
      <VFormTextInput
        :label="$getTranslation(TRANSLATION_GROUPS_OF_ADMINS_EDIT, 'CURRENT_OWNER')"
        :value="currentAdminValue"
        class="mb-4"
        readonly
      />
      <VFormSelectInput
        :label="$getTranslation(TRANSLATION_GROUPS_OF_ADMINS_EDIT, 'CHOOSE_OWNER')"
        :disabled="isLoadingAdminOwnerChange"
        :value="selectValue"
        :options="ownersDataOptions"
        @change="onChange"
      />
      <VFormPlainDataListbox
        :label="$getTranslation(TRANSLATION_GROUPS_OF_ADMINS_EDIT, 'CHOOSE_PARTICIPANTS')"
        :data="groupMembersList"
        :disabled="isLoadingGroupMembers"
        class="mb-4"
        sort-after-change-item
        @change="onChangeParticipant"
      />
    </VLoader>
    <VBackButton
      :label="$getTranslation(TRANSLATION_GROUPS_OF_ADMINS_EDIT, 'BACK')"
      :to="{ name: GROUPS_OF_ADMINS_LIST_ROUTE_NAME }"
    />
  </VCard>
</template>
